// extracted by mini-css-extract-plugin
export default {"items":"Items_items__fvMZu"};